import { LineChart } from "echarts/charts"
import { GridComponent } from "echarts/components"
import * as echarts from "echarts/core"
import { CanvasRenderer } from "echarts/renderers"
import ReactEChartsCore from "echarts-for-react/lib/core"
import { observer } from "mobx-react"
echarts.use([GridComponent, LineChart, CanvasRenderer])

function SimpleLine(props: { data: any[]; compareData: any[] }) {
  const { data, compareData } = props
  return (
    <ReactEChartsCore
      className="pointer-events-none !h-full"
      option={{
        grid: {
          show: false,
          left: 1,
          right: 1,
          top: 2,
          bottom: 2,
        },
        series: [
          {
            data: data,
            itemStyle: {
              color: "#34ACED",
            },
            type: "line",
            smooth: true,
            symbol: data.length === 1 ? "circle" : "none",
            areaStyle: {
              color: {
                type: "linear",
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: "#e2f2fc", // 0% 处的颜色
                  },
                  {
                    offset: 0.5,
                    color: "#edf6fb", // 0% 处的颜色
                  },
                  {
                    offset: 1,
                    color: `#fff`, // 100% 处的颜色
                  },
                ],
              },
            },
          },
          ...(compareData && compareData.length > 0
            ? [
                {
                  data: compareData,
                  itemStyle: {
                    color: "#2EB9F5",
                  },
                  lineStyle: {
                    type: "dotted",
                    width: 1,
                  },
                  type: "line",
                  smooth: true,
                  symbol: compareData.length === 1 ? "circle" : "none",
                  areaStyle: {
                    show: true,
                    color: {
                      type: "linear",
                      x: 0,
                      y: 0,
                      x2: 0,
                      y2: 1,
                      colorStops: [
                        {
                          offset: 0,
                          color: "rgba(46, 185, 245, 0.2)",
                        },
                        {
                          offset: 0.5,
                          color: "rgba(46, 185, 245, 0.1)",
                        },
                        {
                          offset: 1,
                          color: "rgba(46, 185, 245, 0)",
                        },
                      ],
                    },
                  },
                },
              ]
            : []),
        ],
        tooltip: {
          show: false,
        },
        xAxis: {
          show: false,
          boundaryGap: false,
          type: "category",
        },
        yAxis: {
          show: false,
          boundaryGap: false,
          max: function (value: any) {
            return value.max > 4 ? value.max * 1.1 : value.max + 2 // 增加一个合适的偏移量
          },
        },
      }}
      echarts={echarts}
    />
  )
}

export default observer(SimpleLine)
